import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';

import { getControlAccountsRoutes } from './accounts';
import { getControlConnectionsRoutes } from './connections';
import { getControlCouponsRoutes } from './coupons';
import { getControlEmailsRoutes } from './emails';
import { getControlPartnersRoutes } from './partners';
import { getControlPromptsRoutes } from './prompts';
import { getControlSegmentsRoutes } from './segments';
import { getControlSubscriptionsRoutes } from './subscriptions';
import { getControlUsersRoutes } from './users';
import { getControWorkflowsRoutes } from './workflows';
import constants from 'Constants';
import * as paths from 'Paths';



const getControlRoutes = () => {
  return [
    ...getControlAccountsRoutes(),
    ...getControlConnectionsRoutes(),
    ...getControlCouponsRoutes(),
    ...getControlEmailsRoutes(),
    ...getControlPartnersRoutes(),
    ...getControlPromptsRoutes(),
    ...getControlSegmentsRoutes(),
    ...getControlSubscriptionsRoutes(),
    ...getControlUsersRoutes(),
    ...getControWorkflowsRoutes(),
  ]
}


export { getControlRoutes };
